import ComponentName from '../../constant/ComponentName';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { CategoryAction } from '../actions/CategoryActions';

export interface CategoryState {
  pages: Record<string, string>;
}

const initialState: CategoryState = {
  pages: Object.values(ComponentName).reduce((prev: Record<string, string>, curr: ComponentName) => {
    prev[curr] = 'Main';
    return prev;
  }, {}),
};

export type ChangeCategoryAction = {
  component: ComponentName;
  activePage: string;
};

export const categoryReducer = (state = initialState, action: ReduxBaseAction<ChangeCategoryAction, CategoryAction>) => {
  switch (action.type) {
    case 'CHANGE_CATEGORY': {
      state.pages[action.payload.component] = action.payload.activePage;
      return { ...state };
    }
    default:
      return state;
  }
};
